import Typography from '@mui/material/Typography';
import { RouteObject, useRoutes } from 'react-router-dom';
import oops from '../../src/assets/comics/oops.png';
import MainLayout from '../layouts/main/MainLayout';
import Bio from '../pages/Bio';
import Books from '../pages/Books';
import Contact from '../pages/Contact';
import DataProtection from '../pages/DataProtection';
import Home from '../pages/Home';
import Portfolio from '../pages/Portfolio';
import Musica from '../pages/Musica';
import SenticheMusica from '../pages/sentichemusica/sentichemusica';
import ASpassoTraIPianeti from '../pages/aspassotraipianeti/AspassoTraIPianeti';
import PassioneLego from '../pages/passionelego/PassioneLego';
import Robot from '../pages/robottoni/Robot';
import FormulaUno from '../pages/formulauno/FormulaUno';
import AniceRex from '../pages/anicerex/anicerex';
import Dinosauri from '../pages/dinosauri/Dinosauri';
import Trex from '../pages/Trex';

const Routes = () => {
  return useRoutes([routes]);
};

const routes: RouteObject = {
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <Home />,
    },
    {
      path: '/bio',
      element: <Bio />,
    },
    {
      path: '/gallery',
      element: <Portfolio />,
    },
    {
      path: '/books',
      element: <Books />,
    },
    {
      path: '/data',
      element: <DataProtection />,
    },
    {
      path: '/contact',
      element: <Contact />,
    },
    {
      path: '/*',
      element:(
        <Typography
          variant="h3"
          color={'text.secondary'}
          style={{
            fontFamily: 'Yomogi',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
           <img src={oops} alt="" style={{ maxWidth: '400px' }} />
          ⚠ OOPS... Page not found! ⚠
        </Typography>
      ) 
    },
    {
      path: "/music",
      element: <Musica />,
    },
    {
      path: "/sentichemusica",
      element: <SenticheMusica />,
    },
    {
      path: "/aspassotraipianeti",
      element: <ASpassoTraIPianeti />,
    },
    {
      path: "/anicerex",
      element: <AniceRex />,
    },
    {
      path: "/passionelego",
      element: <PassioneLego />,
    },
    {
      path: "/robot",
      element: <Robot />,
    },
    {
      path: "/formulauno",
      element: <FormulaUno />,
    },
    {
      path: "/dinosauri",
      element: <Dinosauri />,
    },
     {
      path: "/trex",
      element: <Trex />,
    }
  ],
};

export default Routes;
